import { nameSchema, optionalStringSchema } from '../validation';

export const searchColSchema = optionalStringSchema(nameSchema);
